module.exports = __webpack_public_path__ + "img/course123_curriculum.0e6262da.png";